// extracted by mini-css-extract-plugin
export default {"coverColHolder":"Sucess_coverColHolder__kE9gz","formHodler":"Sucess_formHodler__fn4xf","formContent":"Sucess_formContent__yQXE9","textHolder":"Sucess_textHolder__vL-K-"};